import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IOperationItem } from "../../api/interface"

interface IOperationsHistorySlice {
  operation: IOperationItem | null
}

const initialState: IOperationsHistorySlice = {
  operation: null,
}

const operationsHistorySlice = createSlice({
  name: "operationsHistory",
  initialState,
  reducers: {
    setOperation: (state, action: PayloadAction<IOperationItem>) => {
      state.operation = action.payload
    },
    resetSlice: () => initialState,
  },
})

export const { setOperation, resetSlice } = operationsHistorySlice.actions

export default operationsHistorySlice.reducer
